module.exports = __webpack_public_path__ + "img/galleria13.c19cdbfd.jpg";